import getQueryParams from '@nike/shop-apis/utils/get-query-params';
import getWebShellClientLocale from '../state/redux-replacement/get-webshellclient-locale';

const getFeatureFlagValue = (featureFlags, featureFlagKey) => {
  const { country } = getWebShellClientLocale();
  const queryParams = getQueryParams();

  const featureFlagOverrides = {};

  queryParams.forEach((value, key) => {
    if (key.startsWith('sc-flags.')) {
      const flagName = key.split('.')[1].split('=')[0];
      featureFlagOverrides[flagName] = value === 'true';
    }
  });

  return Object.hasOwn(featureFlagOverrides, featureFlagKey)
    ? featureFlagOverrides[featureFlagKey]
    : featureFlags[featureFlagKey].includes(country);
};

export default getFeatureFlagValue;
